document.querySelectorAll("[data-accordion='wrapper']").forEach((wrapper) => {
  const trigger = wrapper.querySelector("[data-accordion='trigger']");
  const content = wrapper.querySelector("[data-accordion='content']");
  trigger.addEventListener('click', function () {
    this.classList.toggle('accordion__trigger--active');
    if (content.style.maxHeight == '0px') {
      content.style.maxHeight = content.scrollHeight + 'px';
    } else {
      content.style.maxHeight = '0px';
    }
  });
  content.style.maxHeight = '0px';
});